import React from 'react';
import styled from 'styled-components';
import cloneDeep from 'lodash/cloneDeep';

import { red } from 'utils/style/colors';

import Button from 'components/Button';
import messages from './Messages';
import { display } from 'components/ErrorView/ErrorDialog';
import TaskReminder from './TaskReminder';
import notify from 'components/Notify';
import { IReminderInfo } from 'store/tasks/tasksType';

const ReminderButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface IComponentProps {
  reminders: IReminderInfo[];
  dueDateTitle?: string;
  onSaveButton: () => Promise<any>;
  onAddReminder: () => void;
  assigneeTitle?: string;
  followersTitle?: string;
  removeReminder: (reminderIndex: number) => void;
  onReminderChange: (
    reminderIndex: number,
    inputType: 'reminder' | 'target' | 'timeTarget' | 'message',
    value: string
  ) => void;
}

interface IComponentState {
  saving: boolean;
  reminders: IReminderInfo[];
  showButton?: boolean;
}

class TaskReminders extends React.Component<IComponentProps> {
  state: IComponentState = {
    saving: false,
    reminders: cloneDeep(this.props.reminders),
  };

  static getDerivedStateFromProps(
    nextProps: IComponentProps,
    prevState: IComponentState
  ) {
    const oldTask = prevState.reminders.map((child) => child);
    const newTask = nextProps.reminders.map((child) => child);

    if (JSON.stringify(oldTask) !== JSON.stringify(newTask)) {
      return { showButton: true };
    } else {
      return { showButton: false };
    }
  }

  handleSaveButton = () => {
    this.setState({
      saving: true,
    });
    this.props.onSaveButton().then(
      () => {
        notify(messages.taskUpdated);
        this.setState({
          saving: false,
          reminders: cloneDeep(this.props.reminders),
          showButton: false,
        });
      },
      (err: any) => {
        this.setState({ saving: false });
        display(err);
      }
    );
  };

  render() {
    const {
      reminders,
      dueDateTitle,
      assigneeTitle,
      onAddReminder,
      followersTitle,
      removeReminder,
      onReminderChange,
    } = this.props;

    return (
      <React.Fragment>
        <ReminderButtons>
          <Button color="blue" onClick={onAddReminder}>
            {messages.addReminder}
          </Button>
          {this.state.showButton && (
            <React.Fragment>
              <p className="center" style={{ color: red, margin: '0' }}>
                {messages.taskChanged}
              </p>
              <Button
                color="green"
                onClick={this.handleSaveButton}
                loading={this.state.saving}
              >
                {messages.save}
              </Button>
            </React.Fragment>
          )}
        </ReminderButtons>
        {reminders.map((reminder, index: number) => (
          <TaskReminder
            key={index}
            reminderIndex={index}
            reminder={reminder}
            dueDateTitle={dueDateTitle}
            assigneeTitle={assigneeTitle}
            followersTitle={followersTitle}
            removeReminder={removeReminder}
            onReminderChange={onReminderChange}
          />
        ))}
      </React.Fragment>
    );
  }
}

export default TaskReminders;
